import React from 'react';
import { View } from 'react-native';
import { Icon } from '@ant-design/react-native';
import { DOCUMENT_ITEM_KIND, DOCUMENTS_ICON, DOCUMENTS_ROW } from '../../constants';
import type { TDocumentTypeIconProps } from '../../types';
import { DocumentsPulseIcon } from '../icons';

const renderIcon = (kind: TDocumentTypeIconProps['kind']) => {
    switch (kind) {
        case DOCUMENT_ITEM_KIND.telemonitoringReport:
            return <DocumentsPulseIcon size={DOCUMENTS_ROW.iconSize} color={DOCUMENTS_ICON.color} />;
        case DOCUMENT_ITEM_KIND.appointmentReport:
            return <Icon name="customer-service" size={DOCUMENTS_ROW.iconSize} color={DOCUMENTS_ICON.color} />;
        default:
            return <Icon name="file-text" size={DOCUMENTS_ROW.iconSize} color={DOCUMENTS_ICON.color} />;
    }
};

export const DocumentTypeIcon = ({ kind }: TDocumentTypeIconProps) => (
    <View className="h-[52px] w-[52px] items-center justify-center rounded-[12px] bg-secondary-100">{renderIcon(kind)}</View>
);
